// extracted by mini-css-extract-plugin
export var sectionButton = "section-button-module--sectionButton--CJkZt";
export var sectionButtonActive = "section-button-module--sectionButtonActive--do2ZV";
export var sectionButtonWrapper = "section-button-module--sectionButtonWrapper--PC4ML";